export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-minus-6f981443dfb2a5fdf7cf58d6ead117d7.svg";